import React, {useState, createContext} from 'react';
import QUERY_ALL_CATEGORIES_TAGS from "./Queries/AllCategoriesTags";
import QUERY_PRODUCT_BY_SKU from "./Queries/ProductBySKU";
import QUERY_PRODUCTS_SEARCH from "./Queries/ProductsSearch";
import {useQuery, useLazyQuery} from '@apollo/client'

export const WooContext = createContext();

export const WooSearchProvider = props => {
    const [searchQuery, setSearchQuery] = useState();
    const [productMatch, setProductMatch] = useState();
    const [searchString, setSearchString] = useState();
    const [matchCategory, setMatchCategory] = useState();
    const [matchTag, setMatchTag] = useState();
    const productCategoriesTags = useQuery(QUERY_ALL_CATEGORIES_TAGS),
        products = useLazyQuery(QUERY_PRODUCTS_SEARCH,{
            variables: {
                search: productMatch ? null : searchQuery||null,
                categoryName: productMatch ? null : matchCategory ? matchCategory.name : null,
                tagName: productMatch ? null : matchTag ? matchTag.name : null
            }
        });
    const productMatchQuery = useLazyQuery(QUERY_PRODUCT_BY_SKU, {
        onCompleted: data => setProductMatch(data.product||null),
    });
    const store = {
        searchQueryState: [searchQuery, setSearchQuery],
        matchCategoryState: [matchCategory, setMatchCategory],
        matchTagState: [matchTag, setMatchTag],
        productMatchState: [productMatch, setProductMatch],
        searchStringState: [searchString, setSearchString],
        productCategoriesTags,
        products,
        productMatchQuery
    };

    return (
        <WooContext.Provider value={store}>
            {props.children}
        </WooContext.Provider>
    );
};

